// Frontend Configuration
const config = {
  // API Configuration — must match hrms-backend PORT (default 5000). REACT_APP_API_URL overrides.
  // Empty REACT_APP_API_URL = same-origin requests via the CRA dev-server proxy (e.g. behind a tunnel)
  API_BASE_URL: process.env.REACT_APP_API_URL ?? 'http://localhost:5000',
  API_TIMEOUT: process.env.REACT_APP_API_TIMEOUT || 10000,
  
  // Application Configuration
  APP_NAME: process.env.REACT_APP_NAME || 'HR Management System',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  APP_DESCRIPTION: process.env.REACT_APP_DESCRIPTION || 'Complete HR Employee Management System',
  
  // Authentication Configuration
  TOKEN_STORAGE_KEY: process.env.REACT_APP_TOKEN_STORAGE_KEY || 'hrmgmt_token',
  USER_STORAGE_KEY: process.env.REACT_APP_USER_STORAGE_KEY || 'hrmgmt_user',
  
  // UI Configuration
  THEME: process.env.REACT_APP_THEME || 'light',
  PRIMARY_COLOR: process.env.REACT_APP_PRIMARY_COLOR || '#3b82f6',
  SECONDARY_COLOR: process.env.REACT_APP_SECONDARY_COLOR || '#64748b',
  
  // Feature Flags
  ENABLE_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
  ENABLE_DEBUG: process.env.REACT_APP_ENABLE_DEBUG === 'true',
  ENABLE_NOTIFICATIONS: process.env.REACT_APP_ENABLE_NOTIFICATIONS !== 'false',
  
  // File Upload Configuration
  // Must stay <= the multer limit in hrms-backend (routes/documentUpload.js MAX_UPLOAD_MB)
  // and <= client_max_body_size on the nginx host in front of the API.
  MAX_FILE_SIZE: Number(process.env.REACT_APP_MAX_FILE_SIZE) || 52428800, // 50MB
  ALLOWED_FILE_TYPES: process.env.REACT_APP_ALLOWED_FILE_TYPES || 'image/*,.pdf,.doc,.docx',
  
  // Pagination Configuration
  DEFAULT_PAGE_SIZE: process.env.REACT_APP_DEFAULT_PAGE_SIZE || 10,
  MAX_PAGE_SIZE: process.env.REACT_APP_MAX_PAGE_SIZE || 100,
  
  // Toast Configuration
  TOAST_DURATION: process.env.REACT_APP_TOAST_DURATION || 3000,
  TOAST_POSITION: process.env.REACT_APP_TOAST_POSITION || 'top-right',
  
  // Development Configuration
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',
  
  // API Endpoints
  API_ENDPOINTS: {
    AUTH: {
      LOGIN: '/auth/login',
      REGISTER: '/auth/register',
      LOGOUT: '/auth/logout',
      ME: '/auth/me'
    },
    EMPLOYEE: {
      PROFILE: '/employee/me',
      ATTENDANCE: {
        CHECKIN: '/employee/attendance/checkin',
        CHECKOUT: '/employee/attendance/checkout'
      },
      WORK_REPORT: {
        SUBMIT: '/employee/workreport',
        LIST: '/employee/workreport'
      },
      LEAVE: {
        APPLY: '/employee/leave',
        LIST: '/employee/leave'
      }
    },
    ADMIN: {
      DASHBOARD: '/admin/dashboard',
      EMPLOYEES: {
        LIST: '/admin/employees',
        CREATE: '/admin/employee',
        UPDATE: '/admin/employee',
        DELETE: '/admin/employee',
        LEAVE_SETTINGS: '/admin/employee/:id/leave-settings'
      },
      ATTENDANCE: '/admin/attendance',
      LEAVES: '/admin/leaves',
      LEAVE_APPROVE: '/admin/leave',
      WORK_REPORTS: '/admin/workreports',
      SALARY_REPORTS: '/admin/salary',
      HOLIDAYS: {
        CREATE: '/admin/holiday',
        LIST: '/admin/holidays'
      }
    }
  }
};

// Make configuration globally available
window.config = config;

// Single source of truth for upload size limits, so components no longer hardcode
// their own byte math (which had drifted to a mix of 5 MB and 10 MB).
export const MAX_FILE_SIZE_BYTES = config.MAX_FILE_SIZE;
export const MAX_FILE_MB = Math.floor(config.MAX_FILE_SIZE / (1024 * 1024));

// Export for use in other files
export default config;
